import { getAccessibilityAccommodationsFormFieldsSchema } from "./AccessibilityAccommodationsFormFields";
import { getAllergiesFormFieldsSchema } from "./AllergiesFormFields/AllergiesFormFields.schema";
import { getAnimalAssistanceFormFieldSchema } from "./AnimalAssistanceFormField";
import { getMedicalEquipmentFormFieldsSchema } from "./MedicalEquipmentFormFields";
import { getPersonalWheelchairAssistanceFormFieldsSchema } from "./PersonalWheelchairAssistanceFormFields";
import { getWheelchairAssistanceFormFieldSchema } from "./WheelchairAssistanceFormField";

export const getPassengerAccommodationsFormFieldsSchema = (fieldNames = {}) => {
  const {
    accessibilityAccommodationsFieldNames,
    allergiesFieldNames,
    animalAssistanceFieldNames,
    medicalEquipmentFieldNames,
    personalWheelchairAssistanceFieldNames,
    wheelchairAssistanceFieldNames,
  } = fieldNames;

  return {
    ...getAccessibilityAccommodationsFormFieldsSchema(accessibilityAccommodationsFieldNames),
    ...getAllergiesFormFieldsSchema(allergiesFieldNames),
    ...getAnimalAssistanceFormFieldSchema(animalAssistanceFieldNames),
    ...getMedicalEquipmentFormFieldsSchema(medicalEquipmentFieldNames),
    ...getPersonalWheelchairAssistanceFormFieldsSchema(personalWheelchairAssistanceFieldNames),
    ...getWheelchairAssistanceFormFieldSchema(wheelchairAssistanceFieldNames),
  };
};
